export const searchJobsActionTypes = {
    'PAGE_INIT': 'SEARCH_JOBS_PAGE_INIT',
    'PAGE_NEXT': 'SEARCH_JOBS_PAGE_NEXT',
    'PAGE_PREVIOUS': 'SEARCH_JOBS_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'SEARCH_JOBS_PAGE_REQUEST',
    'PAGE_SUCCESS': 'SEARCH_JOBS_PAGE_SUCCESS',
    'PAGE_ERROR': 'SEARCH_JOBS_PAGE_ERROR',
    'TOGGLE_SELECTION': 'SEARCH_JOBS_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'SEARCH_JOBS_CLEAR_SELECTION',
    'TOGGLE_ALL': 'SEARCH_JOBS_TOGGLE_ALL',
    'ADD_FILTER': 'SEARCH_JOBS_ADD_FILTER',
    'REMOVE_FILTER': 'SEARCH_JOBS_REMOVE_FILTER',
};
